module.exports = __webpack_public_path__ + "static/media/avatar_ghost.8f8af821.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_ghost.png
// module id = 381
// module chunks = 0